export const DEFAULT_REACTION_UNICODE = '0x2764';
